import { Component, createRef } from "react";
import { connect } from "react-redux";
import { Button, Form, FormGroup, Input, Modal, ModalBody, Spinner } from "reactstrap";
import { register } from "../../Redux/Actions/authAction";
import email from "../../assets/img/dashboard-Slicing/Email.svg";
import password from "../../assets/img/dashboard-Slicing/Password.svg";
import close from "../../assets/img/dashboard-Slicing/close.svg";

export class RegisterModal extends Component {
  image = createRef(null);
  
  constructor(props) {
    super(props);
    console.log(this.props);
    this.state = {
      name: "",
      email: "",
      password: "",
      Confirmpassword: "",
      ref:
        window.location.href.split("?").length > 1
          ? window.location.href.split("?")[1].replace("refcode=", "")
          : "",
      verificationDetail: null,
    };
  }

  handleInput = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };

  componentDidMount() {
    const verificationDetailJSON = localStorage.getItem("verification_detail");
    const verificationDetail = JSON.parse(verificationDetailJSON);
    this.setState({ verificationDetail });
  }

  render() {
    const { register, loading, isOpen, toggle } = this.props;
    console.log("register", register);
    console.log(this.state.verificationDetail);
    
    if (register) {
      toggle(); // Close register modal
      this.props.showLoginModal(); // Show login modal instead of redirecting
      return null; // Don't render anything since we're switching modals
    }

    return (
      <Modal isOpen={isOpen} toggle={toggle} centered size="lg">
        <ModalBody className="p-4 rounded" style={{ borderRadius: "16px" }}>
          <div className="text-right d-flex pt-0 pb-2">
            <span className="ml-auto mt-auto mb-auto" onClick={toggle}>
              <img src={close} alt="icon" width="40px" className="close-AM" />
            </span>
          </div>
          
          <div className="text-center mb-4">
            <h3 className="mt-3 mb-4 lgn-heading">Register to Merk Mobile</h3>
            {this.state.verificationDetail ? (
              <div className="bg-site-primary1 mb-3 shadow-sm d-flex align-items-center justify-content-center text-secondary">
                <p className="mb-0">
                  You're signing up with a charity bearing EIN{" "}
                  {this.state.verificationDetail?.ein}
                </p>
              </div>
            ) : (
              ""
            )}
          </div>
          
          <Form
            role="form"
            onSubmit={(e) => {
              e.preventDefault();

              let password = this.state.password;
              let Confirmpassword = this.state.Confirmpassword;
              if (password !== Confirmpassword) {
                alert("Password didn't matched, Password should be same.");
              } else {
                let creds;
                creds = {
                  name: this.state.name,
                  email: this.state.email,
                  password,
                  friendRef: this.state.ref,
                };
                console.log("creds", creds);
                this.props.authRegister(creds);
              }
            }}
          >
            {/* <FormGroup className="mb-3">
              <div className="position-relative form-box">
                <div className="position-absolute form-icon" left="10">
                  <img src={Company} alt="icon" width="16px" />
                </div>
                <Input
                  placeholder="Company Name"
                  name="name"
                  type="name"
                  onChange={this.handleInput}
                  required
                  className="pl-5 py-4 shadow-sm border-0"
                />
              </div>
            </FormGroup> */}
            
            <FormGroup className="mb-3">
              <div className="position-relative form-box">
                <div className="position-absolute form-icon" left="10">
                  <img src={email} alt="icon" width="16px" />
                </div>
                <Input
                  placeholder="Email"
                  name="email"
                  type="email"
                  onChange={this.handleInput}
                  required
                  autoComplete="new-email"
                  className="pl-5 py-4 shadow-sm border-0 rounded"
                  style={{
                    backgroundColor: "#f8f9fa",
                    border: "1px solid #e9ecef",
                    fontSize: "14px",
                    borderRadius: "8px"
                  }}
                />
              </div>
            </FormGroup>
            
            <FormGroup>
              <div className="position-relative form-box">
                <div className="position-absolute form-icon" left="10">
                  <img src={password} alt="icon" width="14px" />
                </div>
                <Input
                  placeholder="Password"
                  name="password"
                  type="password"
                  onChange={this.handleInput}
                  required
                  className="pl-5 py-4 shadow-sm border-0 rounded"
                  style={{
                    backgroundColor: "#f8f9fa",
                    border: "1px solid #e9ecef",
                    fontSize: "14px",
                    borderRadius: "8px"
                  }}
                />
              </div>
            </FormGroup>
            
            <FormGroup>
              <div className="position-relative form-box">
                <div className="position-absolute form-icon" left="10">
                  <img src={password} alt="icon" width="14px" />
                </div>
                <Input
                  placeholder="Confirm Password"
                  name="Confirmpassword"
                  type="password"
                  onChange={this.handleInput}
                  required
                  className="pl-5 py-4 shadow-sm border-0 rounded"
                  style={{
                    backgroundColor: "#f8f9fa",
                    border: "1px solid #e9ecef",
                    fontSize: "14px",
                    borderRadius: "8px"
                  }}
                />
              </div>
            </FormGroup>
            
            {/* <FormGroup>
              <div className="position-relative form-box">
                <div className="position-absolute form-icon" left="10">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    height="16px"
                    viewBox="0 0 576 512"
                    fill="#8fa2bb"
                  >
                    <path d="M64 64C28.7 64 0 92.7 0 128v64c0 8.8 7.4 15.7 15.7 18.6C34.5 217.1 48 235 48 256s-13.5 38.9-32.3 45.4C7.4 304.3 0 311.2 0 320v64c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V320c0-8.8-7.4-15.7-15.7-18.6C541.5 294.9 528 277 528 256s13.5-38.9 32.3-45.4c8.3-2.9 15.7-9.8 15.7-18.6V128c0-35.3-28.7-64-64-64H64zm64 112l0 160c0 8.8 7.2 16 16 16H432c8.8 0 16-7.2 16-16V176c0-8.8-7.2-16-16-16H144c-8.8 0-16 7.2-16 16zM96 160c0-17.7 14.3-32 32-32H448c17.7 0 32 14.3 32 32V352c0 17.7-14.3 32-32 32H128c-17.7 0-32-14.3-32-32V160z" />
                  </svg>
                </div>
                <Input
                  defaultValue={this.state.ref}
                  placeholder="Referral code"
                  name="friendRef"
                  onChange={this.handleInput}
                  required
                  className="pl-5 py-4 shadow-sm border-0"
                />
              </div>
            </FormGroup> */}
            
            <div className="text-center">
              <Button
                className="my-3 w-100 bg-site-primary shadow register-btn rounded"
                type="submit"
                style={{
                  padding: "12px 24px",
                  fontSize: "16px",
                  fontWeight: "600",
                  border: "none",
                  borderRadius: "8px"
                }}
              >
                {loading ? <Spinner size="sm" /> : "Sign Up"}
              </Button>
            </div>
          </Form>

          <div className="text-center mb-2">
            Already have an account?
            <span
              className="text-site-primary ml-1 cursor-pointer"
              onClick={() => {
                toggle();
                this.props.showLoginModal();
              }}
            >
              Sign In
            </span>
          </div>
        </ModalBody>
      </Modal>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    loading: state.auth.requested,
    register: state.auth.registered,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    authRegister: (creds) => dispatch(register(creds)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(RegisterModal); 